import React from 'react';
import {PropTypes} from 'prop-types';
import {BusinessItem} from 'components/fair/fair-business';
import {connect} from 'react-redux';
import {Fairs, Businesses} from 'base/api';
import ReactPaginate from 'react-paginate';
import {toastr} from 'react-redux-toastr';
import axios from 'axios';
import cookie from 'react-cookie';

class AddBusiness extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      items: {},
      businesses: [],
      total: 0,
      offset: 0,
      pageCount: 0,
      searchTerm: '',
      API_URL: '',
      access_token: cookie.load('accessToken') || ''
    }

    this.findStatus = 1;
    this.fnCount = Businesses.actions.countApproved.request;
  }

  componentDidMount() {
    Fairs.actions.get.request({id: this.props.match.params.id}).then(response => {;
      if (response.data) {
        this.setState({
          API_URL: response.data.fair.apiUrl
        }, () => {
          if (response.data.statistic.total_approved_businesses !== 0 || response.data.statistic.total_awaiting_businesses !== 0) {
            this.getAllBussinessOfFair();
          } else {
            this.fnCount({q: '.*'}).then(response => {;

              this.setState({
                total: response.data.total
              });
              this.loadBusinessesFromServer(this.findStatus);
            });
          }
        })
      }
    });
  }

  getAllBussinessOfFair() {
    let params = {
      filter: {
        limit: 10000,
        offset: 0,
        order: 'createdAt DESC',
      }
    }

    axios({
      method: 'GET',
      url: `${this.state.API_URL}/businesses/search`,
      params,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      let businesses = response.data && response.data.results || [];
      this.postAllBusinesses(businesses);
      this.fnCount({q: '.*'}).then(response => {;

        this.setState({
          total: response.data.total
        });
        this.loadBusinessesFromServer(this.findStatus);
      });
    }).catch(error => {
      console.log(error)
    })
  }

  loadBusinessesFromServer(status) {

    Businesses.actions.list.request({
      filter: {
        limit: this.props.limit,
        skip: this.state.offset,
        order: 'createdAt DESC',
        where: {
          status: status,
          name: {
            regexp: `/${this.state.searchTerm}/i`
          }
        }
      }
    }).then(response => {
      this.postLoadBusinesses(response.data);
    });
  }

  postLoadBusinesses(businesses) {
    this.props.dispatch({
      type: 'UPDATE_LIST_BUSINESS_BY_CATEGORY_OF_FAIR',
      listBusinessByCategory: businesses
    });

    let itemKeys = {};
    businesses.map(item => {
      itemKeys[item.id] = item;
    });

    let pageCount = Math.ceil(this.state.total / this.props.limit);
    this.setState({
      items: itemKeys,
      pageCount
    });


  }

  postAllBusinesses(businesses) {
    this.props.dispatch({
      type: 'UPDATE_LIST_ALL_BUSINESS_OF_FAIR',
      list: businesses
    });
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.listBusinesses != this.state.listBusinesses) {
      this.setState({
        listBusinesses: nextProps.listBusinesses,
        businesses: nextProps.listBusinesses,
      });
    }
  }

  onChange(e) {
    this.setState({
      searchTerm: e.target.value,
      offset: 0
    });
  }

  handleSearch(e) {
    e.preventDefault();
    this.loadBusinessesFromServer(this.findStatus);
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.limit);

    this.setState({offset: offset}, () => {
      this.loadBusinessesFromServer(this.findStatus);
    });
  };

  render() {
    return (
      <div>
        <form className="search-container" onSubmit={this.handleSearch.bind(this)}>
          <i className='fa fa-search' />
          <input type="text" className="search-input" value={this.state.searchTerm} placeholder="Tìm theo tên doanh nhiệp" onChange={this.onChange.bind(this)}/>
          <button type='submit' className='btn-submit'>Tìm kiếm</button>
        </form>
        <div className='row'>
          <div className="container-fluid">
            <div className='row'>
              {
                this.state.businesses.map(business => {
                  return (
                    <div className='col-lg-6 business-item'>
                      <BusinessItem key={business.id} fairID={this.props.match.params.id} data={business}/>
                    </div>
                  );
                })
              }
            </div>
          </div>
          <ReactPaginate previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={<a href="">...</a>}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={this.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    listBusinesses: state.fairs.listBusinessByCategory
  };
}

AddBusiness.PropTypes = {
  status: PropTypes.oneOf(['AWAITING', 'ALL', 'REJECTED']),
  limit: PropTypes.number
}

AddBusiness.defaultProps = {
  status: 'ALL',
  limit: 10
}

export default connect(mapStateToProps)(AddBusiness);


// WEBPACK FOOTER //
// ./components/fair/fair-business/AddBusiness.jsx